export default "__VITE_ASSET__cEBY8a_r__"